<p-fieldset>
    <ng-template pTemplate="header">
        <div class="d-flex">
            <fa-icon [icon]='["far","store"]'></fa-icon>
            <div class="mx-2">
                About the Restaurant
            </div>
            <fa-icon [icon]='["far","check-double"]' *ngIf="sectionComplete"></fa-icon>
            <div class="ms-auto">
                <fa-icon [icon]='["far","question-circle"]' (click)="displayModal.emit('about')"></fa-icon>
            </div>
        </div>
    </ng-template>

    <div class="d-flex flex-wrap">
        <div class="mt-2 mx-2 flex-fill">
            <mat-form-field class="w-100">
                <mat-label>Name</mat-label>
                <input matInput (change)="inputAction($event)" type="text" name="accountNameDba" class="px-2" [formControl]="merchantNameControl"
                    [(ngModel)]="application.accountNameDba">
                    <mat-error *ngIf="merchantNameControl.errors">
                        <div *ngIf="merchantNameControl.hasError('required')">Restaurant name is required.</div>
                    </mat-error>
            </mat-form-field>
        </div>

    </div>
    <div class="d-flex flex-wrap">
        <div class="mt-2 mx-2 flex-fill">
            <mat-form-field class="w-100">
                <mat-label>Physical Street Address</mat-label>
                <input matInput (change)="inputAction($event)" #physicalStreet type="text" name="physicalStreet" [formControl]="merchantAddressStreetControl"
                    [(ngModel)]="application.merchantAddress.street" class="w-100" />
                    <mat-error *ngIf="merchantAddressStreetControl.errors">
                        <div *ngIf="merchantAddressStreetControl.hasError('required')">Street address is required.</div>
                    </mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2">
            <mat-form-field class="">
                <mat-label>Suite/Unit</mat-label>
                <input matInput (change)="inputAction($event)" #physicalStreet2 type="text" name="physicalStreet2" 
                    [(ngModel)]="application.merchantAddress.street2" />
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2">
            <mat-form-field class="">
                <mat-label>City</mat-label>
                <input matInput (change)="inputAction($event)" #physicalCity type="text" name="physicalCity" [formControl]="merchantAddressCityControl"
                    [(ngModel)]="application.merchantAddress.city" />
                    <mat-error *ngIf="merchantAddressCityControl.errors">
                        <div *ngIf="merchantAddressCityControl.hasError('required')">City is required.</div>
                    </mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2">
            <mat-form-field class="w-100">
                <mat-label>State</mat-label>
                <mat-select #physicalState name="physicalState" [(ngModel)]="application.merchantAddress.state" [formControl]="merchantAddressStateControl">
                    <mat-option *ngFor="let value of app.references.states" [value]="value.value">
                        {{value.label}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="merchantAddressStateControl.errors">
                    <div *ngIf="merchantAddressStateControl.hasError('required')">State is required.</div>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2">
            <mat-form-field class="">
                <mat-label>Zip Code</mat-label>
                <input matInput (change)="inputAction($event)" #physicalPostalCode type="text" name="physicalPostalCode" [formControl]="merchantAddressPostalCodeControl"
                    [(ngModel)]="application.merchantAddress.postalCode" />
                    <mat-error *ngIf="merchantAddressPostalCodeControl.errors">
                        <div *ngIf="merchantAddressPostalCodeControl.hasError('required')">Zip code is required.</div>
                    </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="d-flex flex-wrap">
        <div class="mt-2 mx-2">
            <mat-form-field class="">
                <mat-label>Phone</mat-label>
                <input matInput (change)="inputAction($event)" #merchantPhone type="text" name="merchantPhone" [formControl]="merchantPhoneControl"
                    [(ngModel)]="application.merchantPhone" [textMask]="{mask: app.references.phoneMask}" />
                    <mat-error *ngIf="merchantPhoneControl.errors">
                        <div *ngIf="merchantPhoneControl.hasError('required')">Phone number is required.</div>
                        <div *ngIf="merchantPhoneControl.hasError('invalidPhonePatternValue')">Phone number does not match the expected format (xxx) xxx-xxxx</div>
                    </mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2">
            <mat-form-field class="">
                <mat-label>Restaurant Email</mat-label>
                <input matInput (change)="inputAction($event)" #merchantEmail type="text" name="merchantEmail" [formControl]="merchantEmailControl"
                    [(ngModel)]="application.merchantEmail" />
                    <mat-error *ngIf="merchantEmailControl.errors">
                        <div *ngIf="merchantPhoneControl.hasError('required')">An email address is required.</div>
                        <div *ngIf="merchantPhoneControl.hasError('email')">Email address is invalid.</div>
                    </mat-error>
            </mat-form-field>
        </div>
        <div class="mt-2 mx-2 flex-fill">
            <mat-form-field class="w-100">
                <mat-label>Website</mat-label>
                <input matInput (change)="inputAction($event)" #merchantWebsite type="text" name="merchantWebsite" [formControl]="merchantWebsiteControl"
                    [(ngModel)]="application.website" />
                    <mat-error *ngIf="merchantWebsiteControl.errors">
                    
                    </mat-error>
            </mat-form-field>
        </div>
    </div>
</p-fieldset>